/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class GameControlBtns extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    const lines = ABCyaPhaser.Images.addImage(0, 0, 'controls-separator', this).setOrigin(0, 0);

    this.infoBtn = this.scene.add.container();
    const infoBg = ABCyaPhaser.Graphics.addRect(0, 0, 42, 42, '0x000000', this.infoBtn, { x: 0, y: 0 }, true, true).setAlpha(.01);
    const infoDisplay = ABCyaPhaser.Images.addImage(0, 0, 'btnInfo', this.infoBtn).setOrigin(0, 0);

    this.speakerBtn = this.scene.add.container();
    const speakerBg = ABCyaPhaser.Graphics.addRect(0, 0, 30, 30, '0x000000', this.speakerBtn, { x: 0, y: 0 }, true, true).setAlpha(.01);
    this.speakerDisplay = ABCyaPhaser.Images.addImage(0, 0, 'speaker-on', this.speakerBtn).setOrigin(0, 0);

    this.speakerBtn.x = lines.getBounds().width / 2 + 10;

    this.add([this.infoBtn, this.speakerBtn]);

    // this.infoBtn.setSize(42, 42);
    // this.speakerBtn.setSize(30, 30);
    // this.infoBtn.setInteractive();
    // this.speakerBtn.setInteractive();

    infoBg.on('pointerup', () => {this.handleBtnClick(this.infoBtn);});
    speakerBg.on('pointerup', () => {this.handleBtnClick(this.speakerBtn);});
  }

  showSoundState(soundIsOn) {
    const targetFrame = soundIsOn ? 'speaker-on' : 'speaker-off';
    this.speakerDisplay.setFrame(targetFrame);
  };

  handleBtnClick(e) {
    const controlName = e === this.infoBtn ? 'info' : 'music';
    this.emit('CONTROLS_CLICK', controlName);
  };
}